import type { ThemeDefinition } from 'vuetify';

/**
 * PerformX palette, matching the rule builder so the two look like one product.
 *
 * Inlined from `src/theme/ruleSetBuilderTheme.ts` in `performx-ruleset-builder`
 * rather than imported: it was one of only two things the sale intake app reached
 * across the repo boundary for, and it is four lines. The `ruleSetBuilderCssVars`
 * export alongside it is for the library's own components and is not needed here.
 */
export const performxTheme: ThemeDefinition = {
    dark: false,
    colors: {
        primary: '#077daf',
        secondary: '#002a4e',
    },
};
